import * as React from "react";
// import Resolutions from "./../utils/Resolution";
import BaseComponent from "src/engine/ui/BaseComponent";

interface IResolution {
    width: number;
    offset?: number;
    maxFontSize?: number | undefined; //最大的fontsize，解决有些宽屏幕字体超大的情况
    isResolution?: boolean;
    // rem相关，设置后，fontsize最大为100，宽度720，解决宽屏下样式变形等问题
    maxWidth?: boolean;
    isHscreen?: boolean;
    hWidth?: number;
    resizeScreen?: boolean;
    mobStore?: string;
}

const per = "RESOLUTION_";

export default class Resolution extends BaseComponent<IResolution> {
    static init = false;
    state = {
        screenWidh: null,
    };
    htmlFs: number;
    componentDidMount() {
        if (!this.htmlFs) {
            this.htmlFs = this.getHtmlFs(document.documentElement);
        }
        this.resize();
        // $(window).resize(this.resize);
        window.onresize = this.resize.bind(this, undefined);
        // window.addEventListener("resize", this.resize);
    }

    UNSAFE_componentWillReceiveProps(nextProps: IResolution) {
        if (
            nextProps.offset !== this.props.offset ||
            // nextProps.width !== this.props.width ||
            nextProps.isHscreen !== this.props.isHscreen
        ) {
            this.resize(nextProps);
        }
        // if (nextProps.maxFontSize !== this.props.maxFontSize) {
        //     this.resize(nextProps, true);
        // }
    }

    getHtmlFs = (html: Element) => {
        return parseFloat(window.getComputedStyle(html, null)["font-size"]);
    };

    resize = (nextProps?: IResolution, update?: boolean) => {
        const isResolution = window[`${per}noResolution`];
        const maxWidth = window[`${per}useMaxWidth`];
        const mobStore = window[`${per}mobStore`];
        const { width: wWidth, hWidth = 1280, isHscreen, offset, resizeScreen } = nextProps || this.props;
        if (mobStore === "mi") return;
        const html = document.documentElement;
        let width = wWidth;
        if (resizeScreen && isHscreen) {
            if (window.screen.width > window.screen.height) {
                width = hWidth;
            }
        }
        if (!html || !width) return;
        const htmlFs = this.htmlFs;
        let screenWidh;
        if (maxWidth) {
            screenWidh = Math.min(Number(offset || html.offsetWidth), width);
        } else {
            screenWidh = Number(offset || html.offsetWidth);
        }
        const mediaFs = (100 / width) * screenWidh;

        if (isResolution === true) {
            html.style.fontSize = "50px";
            return;
        }

        if (!this.state.screenWidh || this.state.screenWidh !== screenWidh) {
            this.setState({
                screenWidh,
            });
            // } else if (update && maxFontSize && maxFontSize > 0 && mediaFs > maxFontSize) {
            //     //处理有些内容文字等因为屏幕宽度大，而变得很大的问题，此方式有点问题
            //     mediaFs = maxFontSize;
        } else if (this.state.screenWidh === screenWidh) {
            // return;
        }

        html.style.fontSize = mediaFs + "px"; //根据页面大小算出font-size
        // 解决移动端系统设置字体变大变小后页面rem计算出问题的问题
        if (htmlFs !== 50 && htmlFs !== mediaFs && (htmlFs > mediaFs + 1 || htmlFs < mediaFs - 1)) {
            html.style.fontSize = "100px";
            html.style.fontSize = (mediaFs / htmlFs) * mediaFs + "px";
        }
    };
    render() {
        return <div>{this.props.children}</div>;
    }
}
